import type {
  ModelsAssetsAssetInformationModel,
  ModelsAssetsAssetModel,
  ModelsAssetsAssetsBorrowerInformation,
  ModelsBorrower,
} from '~/__generated__/api';

export function transformGetResponsePayload(
  data: ModelsAssetsAssetsBorrowerInformation,
) {
  const {
    assets,
    excludedAssets,
    borrowers,
    assetsSummaryInformation,
    loanProductType,
    displayAuditHistory,
    assetsFeatureFlags,
    reservesComment,
  } = data;

  const filteredBorrowers = transformBorrowers(borrowers.borrowers);

  const transformedAssets = transformAssets(assets);

  return {
    excludedAssets: mapExcludedAssets(excludedAssets, filteredBorrowers),
    transformedAssets,
    filteredBorrowers,
    assetsSummaryInformation,
    loanProductType,
    displayAuditHistory,
    assetsFeatureFlags,
    reservesComment,
    totalAssets:
      transformedAssets?.reduce((sum, obj) => sum + obj.balance, 0) ?? 0,
  };
}

function transformBorrowers(borrowers: ModelsBorrower[]) {
  const uniqueBorrowers = new Map<number, ModelsBorrower>();

  borrowers.forEach((borrower) => {
    uniqueBorrowers.set(borrower.customerRecordId, borrower);
  });

  return Array.from(uniqueBorrowers.values());
}

function transformAssets(assets: ModelsAssetsAssetInformationModel[]) {
  return assets?.map((asset) => ({ ...asset, ...asset.asset }));
}

function mapExcludedAssets(
  excludedAssetsArray: ModelsAssetsAssetModel[],
  borrowersArray: ModelsBorrower[],
) {
  const borrowersLookup = borrowersArray.reduce((lookup, borrower) => {
    lookup[borrower.customerRecordId] = borrower;
    return lookup;
  }, {});

  return excludedAssetsArray?.map((excludedAsset) => ({
    ...excludedAsset,
    borrowers: borrowersLookup[excludedAsset.customerRecordId]
      ? [borrowersLookup[excludedAsset.customerRecordId]]
      : [],
  }));
}
